import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=auth
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  };

  const login = async (email, password) => {
    setError("");
    try {
      const ident = email.trim();
      // Sem "@" = login de FORNECEDOR (usuário/senha)
      const { data } = ident.includes("@")
        ? await api.post("/auth/login", { email: ident, password })
        : await api.post("/auth/login-fornecedor", { username: ident, password });
      setUser({ id: data.id, email: data.email, name: data.name, role: data.role, base: data.base, must_change_password: data.must_change_password, modules: data.modules || null });
      return true;
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
